module.exports = __webpack_public_path__ + "static/media/wmv.c8b99c96.png";